import { Beneficiary } from "../../Beneficiary/beneficiary";
import { Network } from "../../Benefit/network";
import { UniqueSequentialNumber } from "../../financial-satatement/unique-sequential-number";

export class AuditSale {
  private salesOrderKey: string;
  private uniqueSequentialNumber: UniqueSequentialNumber;
  private uniqueSequentialNumberCorrelated: UniqueSequentialNumber;
  private beneficiary: Beneficiary;
  private transactionDate: string;
  private salesAction: string;
  private networkInfo: Network;
  private errorCauses: Array<any>;
  private status: string;
  private source: string;
  private hasPendingMedicalPrescriptionScans: boolean;

  public getSalesOrderKey(): string {
    return this.salesOrderKey;
  }

  public setSalesOrderKey(salesOrderKey: string): void {
    this.salesOrderKey = salesOrderKey;
  }

  public getUniqueSequentialNumber(): UniqueSequentialNumber {
    return this.uniqueSequentialNumber;
  }

  public setUniqueSequentialNumber(uniqueSequentialNumber: UniqueSequentialNumber): void {
    this.uniqueSequentialNumber = uniqueSequentialNumber;
  }

  public getUniqueSequentialNumberCorrelated(): UniqueSequentialNumber {
    return this.uniqueSequentialNumberCorrelated;
  }

  public setUniqueSequentialNumberCorrelated(uniqueSequentialNumberCorrelated: UniqueSequentialNumber): void {
    this.uniqueSequentialNumberCorrelated = uniqueSequentialNumberCorrelated;
  }

  public getBeneficiary(): Beneficiary {
    return this.beneficiary;
  }

  public setBeneficiary(beneficiary: Beneficiary): void {
    this.beneficiary = beneficiary;
  }

  public getTransactionDate(): string {
    return this.transactionDate;
  }

  public setTransactionDate(transactionDate: string): void {
    this.transactionDate = transactionDate;
  }

  public getSalesAction(): string {
    return this.salesAction;
  }

  public setSalesAction(salesAction: string): void {
    this.salesAction = salesAction;
  }

  public getNetworkInfo(): Network {
    return this.networkInfo;
  }

  public setNetworkInfo(networkInfo: Network): void {
    this.networkInfo = networkInfo;
  }

  public getErrorCauses(): Array<any> {
    return this.errorCauses;
  }

  public setErrorCauses(errorCauses: Array<any>): void {
    this.errorCauses = errorCauses;
  }

  public getStatus(): string {
    return this.status;
  }

  public setStatus(status: string): void {
    this.status = status;
  }

  public getSource(): string {
    return this.source;
  }

  public setSource(source: string): void {
    this.source = source;
  }

  public getHasPendingMedicalPrescriptionScans(): boolean {
    return this.hasPendingMedicalPrescriptionScans;
  }

  public setHasPendingMedicalPrescriptionScans(hasPendingMedicalPrescriptionScans: boolean): void {
    this.hasPendingMedicalPrescriptionScans = hasPendingMedicalPrescriptionScans;
  }
}
